<template>
  <div class="bg-dark-920 text-dark-50 min-h-svh">
    <div class="absolute top-0 left-0 w-full z-10">
      <div class="max-w-wrapper-xs mx-auto px-3 relative">        
        <div class="flex items-center relative space-x-3 h-20">
          <NuxtLink :to="'/'" class="flex items-center space-x-1.5 shrink-0">
            <div>
              <img :src="logoVibesDark" class="h-6">
              <p class="uppercase text-right text-3xs font-black text-white">Backstage</p>
            </div>

            <img src="assets/img/flags/lgbtqia_animated_xl.png" class="h-9" />
          </NuxtLink>

          <div class="grow" />

          <ButtonBase size="sm" :to="{ name: 'dashboard' }" color="intentions" v-if="currentUser?.backstage">
            <UserPicture :user="currentUser" size="sm" class="-ml-3 mr-2" />

            Mon backstage
          </ButtonBase>
          <ButtonBase size="sm" :to="{ query: { join: true } }" color="intentions" v-else>
            Créer un compte
          </ButtonBase>
        </div>
      </div>
    </div>

    <div>
      <slot />
    </div>

    <PopinBase :is-active="route?.query?.join ? true : false" @close="() => router.push({ query: { join: undefined }})" size="3xs">
      <template #body>
        <div class="text-center relative">
          <div class="h-44 relative">
            <img :src="bannerGradient" class="absolute top-0 left-0 h-full w-full" />

            <div class="absolute left-0 right-0 -bottom-1 h-full bg-gradient-to-t from-dark-920 to-dark-920/0" />
          </div>
          
          <div class="relative p-6 -mt-36">
            <img src="assets/img/logo/backstage-square.png" class="size-16 rounded-xl mx-auto shrink-0" />

            <p class="text-2xl max-w-sm mx-auto !leading-tight font-bold mt-4 text-white">Crée ton Backstage gratuitement</p>
            <p class="mt-2 max-w-xs mx-auto leading-tight">Fonctionnalités avancées pour être visible sur Vibes</p>
            
            <div class="text-left mt-4">
              <div class="grid grid-cols-2 gap-2 text-left">
                <NuxtLink
                  class="flex flex-col justify-end border-2 border-dark-800 p-4 h-32 rounded-2xl bg-cover cursor-pointer text-white"
                  v-for="(proType, proId) in proTypes"
                  :to="{ name: 'auth-register', query: { type: proId } }"
                  :key="proId"
                >
                  <ImageEmoji :name="proType.emoji" size="sm" class="size-8 mb-2" />
                  <p class="font-bold text-md">{{ proType.title }}</p>
                  <p class="text-sm font-medium text-white/60 leading-[1.1]">{{ proType.description }}</p>
                </NuxtLink>
              </div>

              <div class="mt-4 text-center">
                <ButtonLink :to="{ name: 'auth-login' }">Se connecter</ButtonLink>
              </div>
            </div>
          </div>
        </div>
      </template>
    </PopinBase>
    
    <footer class="bg-dark-850 p-8 relative">
      <div class="max-w-wrapper-lg mx-auto px-6 md:flex space-y-8 md:space-y-0 md:space-x-8 relative z-10">
        <div class="md:pr-8">
          <img src="@/assets/img/logo/backstage-square.png" class="w-20 rounded-2xl">
        </div>

        <div class="flex-1 shrink-0 space-y-6" v-for="(column, i) in columns" :key="i">
          <div v-for="(section, j) in column" :key="j">
            <p class="font-bold text-lg mb-2">{{ section.title }}</p>

            <div class="space-y-1">
              <div v-for="(link, k) in section.items" :key="k">
                <ButtonLink class="cursor-pointer hover:underline" v-bind="link" is-invert> 
                  {{ link.label }}
                </ButtonLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <ToasterBase />
  </div>
</template>

<script lang="ts" setup>
import logoVibesDark from '@/assets/img/logo/logo-white.png'
import bannerGradient from '@/assets/img/gradients/hard/gradient-6.jpg'
import UserStore from '@/store/user'

const userStore = UserStore()
const { currentUser } = storeToRefs(userStore)

const columns = computed(() => [
  [
    {
      title: `À propos de Vibes`,
      items: [
        {
          label: `Page d'accueil`,
          to: '/'
        }
      ]
    }
  ],
  [
    {
      title: `Réseaux`,
      items: [
        {
          label: `Instagram`,
          href: 'https://www.instagram.com/vibes.lgbt'
        },
        {
          label: `Meetup Paris`,
          href: 'https://www.meetup.com/fr-FR/vibes-lgbtq-amities-rencontres'
        },
      ]
    }
  ]
])

const route = useRoute()
const router = useRouter()

const proTypes = {
  'place': {
    title: 'Établissement',
    description: 'Bar, café, boutique...',
    emoji: 'Hot+Beverage'
  },
  'event': {
    title: 'Événement',
    description: 'Festival, soirée,...',
    emoji: 'Mirror+Ball'
  },
  'group': {
    title: 'Association',
    description: 'Conviviale, engagée...',
    emoji: 'Rainbow'
  },
  'independant': {
    title: 'Indépendant•e',
    description: 'Artiste, coach...',
    emoji: 'Writing+Hand'
  },
  'individual': {
    title: 'Particulier',
    description: `Orga passionné•e`,
    emoji: 'Red+Heart'
  },
  'other': {
    title: 'Autres',
    description: 'Marque, start-up...',
    emoji: 'Sparkles'
  }
}


onMounted(() => {
  setTimeout(() => document.body.classList.add('dark'))
})

</script>